import { render } from "./SiteAffectedDetailsModal.vue?vue&type=template&id=120d3bae&scoped=true"
import script from "./SiteAffectedDetailsModal.vue?vue&type=script&lang=js"
export * from "./SiteAffectedDetailsModal.vue?vue&type=script&lang=js"

import "./SiteAffectedDetailsModal.vue?vue&type=style&index=0&id=120d3bae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120d3bae"]])

export default __exports__